// extracted by mini-css-extract-plugin
export var banner = "_kg-0";
export var settingRow = "_kg-2";
export var titleIcon = "_kg-1";